import { ANNOTATION_VALUE } from "@/constants/annotation-values"

import {
  SET_COMPARISON_OPERATOR,
  type TargetCondition,
} from "@/types/metrics/contracts"

export const yesNoBadgeShapeClasses =
  "rounded-md h-[28px] min-w-11 w-fit px-3 text-sm font-medium inline-flex items-center justify-center shrink-0"

export const yesNoBadgeColorClasses = {
  success: "bg-coval-success-surface text-coval-success-on-surface",
  danger: "bg-coval-danger-surface text-coval-danger-on-surface",
  default: "bg-surface-1 text-coval-text-muted",
} as const

export const yesNoBadgeNAClasses = "bg-surface-1 text-coval-text"

export const getAnnotationMetricColor = (
  value: string,
  targetCondition?: TargetCondition,
): keyof typeof yesNoBadgeColorClasses => {
  if (
    value === ANNOTATION_VALUE.UNKNOWN ||
    (value !== ANNOTATION_VALUE.YES && value !== ANNOTATION_VALUE.NO)
  ) {
    return "default"
  }

  if (!targetCondition || !("target_values" in targetCondition)) {
    return value === ANNOTATION_VALUE.YES ? "success" : "danger"
  }

  const { target_values, comparison_operator } = targetCondition
  const valueInTarget = target_values.includes(value)
  const isIdeal =
    comparison_operator === SET_COMPARISON_OPERATOR.IN
      ? valueInTarget
      : !valueInTarget

  return isIdeal ? "success" : "danger"
}
